import React, { useState } from 'react';
// eslint-disable-next-line no-unused-vars
import { ChromePicker, PhotoshopPicker, SliderPicker } from 'react-color';
import PropTypes from 'prop-types';
import { useField } from 'formik';

function ColorPickerButton({ label, color, setColor, fieldName }) {
    const [show, serShow] = useState(false);
    const popover = {
        position: 'absolute',
        zIndex: '2',
    };
    const cover = {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
    };

    const handleClick = () => {
        serShow((prev) => !prev);
    };

    const handleClose = () => {
        serShow(false);
    };

    const [, , helpers] = useField(fieldName);
    const handleChangeComplete = (color) => {
        setColor(color.hex);

        helpers.setValue(color.hex);
    };
    return (
        <div>
            <a onClick={handleClick}>{label}</a>
            {show ? (
                <div style={popover}>
                    <div
                        style={cover}
                        onClick={handleClose}
                    />
                    <ChromePicker
                        color={color}
                        onChangeComplete={handleChangeComplete}
                        disableAlpha
                    />
                </div>
            ) : null}
        </div>
    );
}

ColorPickerButton.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    color: PropTypes.string.isRequired,
    setColor: PropTypes.func.isRequired,
    fieldName: PropTypes.string.isRequired,
};

export default ColorPickerButton;
